export const Role = {
  User: 100,
  Admin: 101,
  SuperAdmin: 1,
  ClinicAdmin: 2,
  SiteAdmin: 3,
  Interviewer: 4,
  MultiSiteAdmin: 5,
  SingleUserProvider: 6,
  MultiUserProvider: 7,
  CareManager: 8,
  PsychiatricConsult: 9,
  MultiSiteRater: 10,
  MultiSiteStudyAdmin: 11,
  AccountStudyAdmin: 12,
  SiteStudyAdmin: 13,
  Rater: 14,
  Auditor: 15,
  JobScheduler: 201,
};
